/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"

import SEO from "../components/seo/seo.component"
import { AppContainer, MainContainer } from "../styles/app.styles"
import Footer from "./footer/footer.component"
import Header from "./header/header.component"

const Layout = ({ seo, children, slug, hideFooter }) => {
  return (
    <AppContainer>
      {seo && <SEO data={seo} />}
      <Header />
      <MainContainer>
        {children}
        <Footer slug={slug} hideFooter={hideFooter} />
      </MainContainer>
    </AppContainer>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
